import React from 'react';
import { useSelector } from 'react-redux';

import Button, { ButtonType } from 'components/Button';
import FormNavigation from 'components/FormNavigation';
import FormContainer from 'components/LoanForm/FormContainer';
import DisabledDetailField from 'components/LoanForm/ConfirmReapplyDetails/DisabledDetailField';
import {
  CONFIRM_DETAILS_SUBTITLE,
  CONFIRM_DETAILS_TITLE,
} from 'components/LoanForm/ConfirmReapplyDetails/confirmReapplyDetailsUtils';
import { FlowComponentType } from 'routes/types';
import { ConfirmPrefillDetailsResult } from 'enums/FlowNextResults';
import { getAuthData } from 'selectors/getAuthData';
import { getYourContactData } from 'selectors/getYourContact';
import { getYourNameData } from 'selectors/yourName';

import fieldStyles from 'components/LoanForm/ConfirmReapplyDetails/ConfirmReapplyDetails.module.scss';

import styles from './ConfirmPrefillDetails.module.scss';

const ConfirmPrefillDetails = ({ navigationInfo, handleNext }: FlowComponentType): JSX.Element => {
  const { prefill } = useSelector(getAuthData);
  const { phone_number: phoneNumber } = useSelector(getYourContactData);
  const { first_name: firstName, last_name: lastName } = useSelector(getYourNameData);
  const masked = prefill?.masked;

  return (
    <div data-testid="confirm-prefill-details">
      <FormNavigation {...navigationInfo} />
      <FormContainer title={CONFIRM_DETAILS_TITLE} subtitle={CONFIRM_DETAILS_SUBTITLE}>
        <div className={fieldStyles.fields}>
          <DisabledDetailField label="Name" name="name" value={masked?.name || `${firstName} ${lastName}`} />
          <DisabledDetailField label="Phone" name="phone" value={masked?.phone || phoneNumber} />
          {masked?.email ? <DisabledDetailField label="Email" name="email" value={masked.email} /> : null}
          {masked?.dob ? <DisabledDetailField label="Date of birth" name="dob" value={masked.dob} /> : null}
          {masked?.address ? <DisabledDetailField label="Address" name="address" value={masked.address} /> : null}
          {masked?.ssn ? <DisabledDetailField label="SSN" name="ssn" value={masked.ssn} /> : null}
        </div>

        <div className={styles.buttonsContainer}>
          <Button onClick={() => handleNext(ConfirmPrefillDetailsResult.Confirmed)} className={styles.button}>
            This is correct
          </Button>
          <Button
            type={ButtonType.Inverted}
            onClick={() => handleNext(ConfirmPrefillDetailsResult.UpdateFields)}
            className={styles.button}
          >
            Make a change
          </Button>
        </div>
      </FormContainer>
    </div>
  );
};

export default ConfirmPrefillDetails;
